import React, { useEffect } from 'react';
import { ePermissions } from 'types/administration/userAdministration/ePermissions';
import { useParams } from 'react-router-dom';
import { useAppDispatch } from 'store/store';
import { useSelector } from 'react-redux';
import { RootStore } from 'store/types';
import { getUnderwriterProfileAsyncAction } from 'store/administration/pricing/slices';
import { UnderwriterProfileDetailPage } from './UnderwriterProfileDetailPage';
import { underwriterProfileURLGenerator } from '../../../utilities/administration/underwriterProfileURLGenerator';
import { ErrorBoundaryTW } from '../../../tailwindComponents/errorBoundary/ErrorBoundaryTW';
import { PermissionWrapper } from '../../../components/accessControl/PermissionWrapper';
import { useHasPermissions } from '../../../components/accessControl/hooks/useHasPermissions';
import { eUSAState } from '../../../ui-toolkit/enums/states';
import { eUnderwriter } from '../../../ui-toolkit/enums/eUnderwriter';

export const UnderwriterProfileDetailContainer: React.FC = () => {
  const params = useParams<{ state: eUSAState; underwriter?: eUnderwriter; zone?: string }>();
  const url = underwriterProfileURLGenerator(params);

  const hasReadPermission = useHasPermissions([ePermissions.AuthIdentityRead]);
  const dispatch = useAppDispatch();
  const { getUnderwriterProfileDetail } = useSelector((store: RootStore) => store.pricing);

  useEffect(() => {
    if (hasReadPermission) {
      dispatch(getUnderwriterProfileAsyncAction(url));
    }
  }, [hasReadPermission, dispatch, url]);

  return (
    <PermissionWrapper allowedPermissions={[ePermissions.AuthIdentityRead]}>
      <ErrorBoundaryTW>
        <UnderwriterProfileDetailPage fetchDataState={getUnderwriterProfileDetail} />
      </ErrorBoundaryTW>
    </PermissionWrapper>
  );
};
